import { HeroHookFormDefaultsConfig } from '@rachelallyson/hero-hook-form';

/**
 * Default field props matching current INPUT_SETTINGS
 * These will be applied globally via HeroHookFormProvider
 */
export const heroHookFormDefaults: HeroHookFormDefaultsConfig = {
  checkbox: {
    size: 'sm',
  },
  input: {
    labelPlacement: 'inside',
    size: 'sm',
    variant: 'bordered',
  },
  select: {
    labelPlacement: 'inside',
    size: 'sm',
    variant: 'bordered',
  },
  switch: {
    size: 'sm',
  },
  textarea: {
    labelPlacement: 'inside',
    size: 'sm',
    variant: 'bordered',
  },
};
